<template>
    <div
        :class="[
            'input-wrapper',
            'input-wrapper--radio',
            'input-wrapper--' + name,
        ]"
    >
        <label :class="[hasError ? 'has-error' : '']">
            <input
                type="radio"
                :name="name"
                class="visually-hidden"
                tabindex="-1"
                :checked="checked"
                @change="handleChange"
            />
            <div
                :class="[
                    'input__label',
                    'input__label--radio',
                    'input__label--' + name,
                ]"
                tabindex="0"
                role="radio"
                @keydown.enter.prevent="handleChange"
                @keydown.space.prevent="handleChange"
            >
                {{ label }}
            </div>
        </label>
        <Error v-if="handlesError" :name="name" />
    </div>
</template>

<script lang="ts">
import {
    defineComponent,
    ref,
    computed,
    watch,
    onMounted,
    PropType,
} from 'vue';
import { useStore } from 'vuex';
import Error from '@/components/basic/Error.vue';
import { DELETE_ERROR } from '@/constants/mutation-types';

export default defineComponent({
    name: 'Radio',
    components: {
        Error,
    },
    props: {
        label: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        value: {
            type: [Boolean, String, Number] as PropType<
                boolean | string | number
            >,
            required: true,
        },
        checked: {
            type: Boolean,
            default: false,
        },
        handlesError: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['updateValue'],
    setup(props, { emit }) {
        const store = useStore();
        const hasError = ref(false);

        const isErrorsChanged = computed(() => store.state.isErrorsChanged);
        const formDataStore = computed(() => store.state.formData);

        const handleChange = () => {
            store.commit(DELETE_ERROR, props.name);
            emit('updateValue', props.value);
        };

        const loadData = () => {
            if (formDataStore.value.hasOwnProperty(props.name)) {
                if (props.name !== 'usaTaxPayer') {
                    handleChange();
                }
            }
        };

        watch(isErrorsChanged, () => {
            hasError.value = store.state.errors.get(props.name);
        });

        onMounted(() => {
            loadData();
        });

        return {
            hasError,
            handleChange,
        };
    },
});
</script>
